import { Component } from '@angular/core';
import { AdminActionsDirective } from '@app/main/admin/directives/admin-actions.directive';
import { AdminService } from '../../../../admin.service';
import { IHyperlink } from '@shared/interfaces';
import { DialogService } from '@shared/services';
import { ModuleService } from '@shared/services/module.service';

@Component({
    selector: 'app-admin-hyperlink-info',
    templateUrl: './admin-hyperlink-info.component.html',
    styleUrls: ['./admin-hyperlink-info.component.scss'],
    standalone: false
})
export class AdminHyperlinkInfoComponent extends AdminActionsDirective {
    constructor(adminService: AdminService, dialogService: DialogService, moduleService: ModuleService) {
        super(adminService, dialogService, moduleService);
    }

    get item(): IHyperlink {
        return this.selectedItem;
    }
}
